// Feed de la sección 6 y del KPI «Cambios 30d». Cuelga de la query key de parámetros, así que
// guardar lo invalida junto con el listado.
import { useQuery } from '@tanstack/react-query';
import {
    listRecentParameterChanges,
    PARAMETERS_QUERY_KEY,
} from '@/api/services/loan-config/loan-config.client';

export const RECENT_CHANGES_WINDOW_DAYS = 30;
export const RECENT_CHANGES_ROWS = 20;

export function useRecentParameterChanges(enabled: boolean) {
    return useQuery({
        queryKey: [
            ...PARAMETERS_QUERY_KEY,
            'audit',
            'recent',
            RECENT_CHANGES_WINDOW_DAYS,
            RECENT_CHANGES_ROWS,
        ],
        queryFn: () => listRecentParameterChanges(RECENT_CHANGES_WINDOW_DAYS, RECENT_CHANGES_ROWS),
        enabled,
        staleTime: 60_000,
    });
}
